import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";

function Content() {
  const menuList = JSON.parse(localStorage.getItem("menu_list")) || [];
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 849);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 849);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <AppSettings.Consumer>
      {({ appContentClass, appSidebarMinify }) => (
        <div
          className={"app-content " + appContentClass}
          // style={{
          //   marginLeft: isMobile
          //     ? "0"
          //     : appSidebarMinify
          //     ? "20px"
          //     : menuList?.length > 0
          //     ? "220px"
          //     : "",
          // }}
          style={{
            marginLeft: "220px",
            // height: "90vh",
          }}
        >
          <Outlet />
        </div>
      )}
    </AppSettings.Consumer>
  );
}

export default Content;
